import { FeatureFlag } from './types/FeatureFlag'

/**
 * Configuration for feature flags that are safe to expose publicly via unauthenticated endpoints.
 *
 * Guidelines for adding feature flags to this list:
 * - Must NOT expose sensitive business logic or internal system capabilities
 * - Must NOT reveal security-sensitive information
 * - Should only include flags that affect user experience or client-side behavior
 * - Examples of SAFE flags: UI/UX toggles, authentication method availability, client feature availability
 * - Examples of UNSAFE flags: internal testing, admin capabilities, payment configurations, system optimizations
 */
export const PUBLIC_FEATURE_FLAGS: readonly FeatureFlag[] = [
  FeatureFlag.RiderPhonePin,
  // Add other safe-to-expose feature flags here as needed
] as const

/**
 * Utility function to filter an organization's feature flags to only include those that are safe to expose publicly.
 * @param organizationFeatureFlags - The full list of feature flags for an organization
 * @returns Array of feature flags that are safe to expose publicly
 */
export function getPublicFeatureFlags(organizationFeatureFlags: FeatureFlag[]): FeatureFlag[] {
  return organizationFeatureFlags.filter((flag) => PUBLIC_FEATURE_FLAGS.includes(flag))
}
